import { initSlider } from "../../ui";
import "./tips-and-tricks.scss";

document.addEventListener("DOMContentLoaded", () => {
  initSlider({
    containerSelector: ".js-jiffytransfers-landing-v2-tips-and-tricks",
    loop: false,
    autoplay: false,
    speed: 500,
    spaceBetween: 16
  });
});
